module.exports = __webpack_public_path__ + "app/principal/containers-list-j_bnovIn.html";